import { Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";
import { useEffect } from "react";
import {
  CreditCardIcon,
} from "@heroicons/react/24/outline";

export default function InactiveStudioSettings() {
  const location = useLocation();
  const navigate = useNavigate();

  // Extract the active tab from the current path
  const pathSegments = location.pathname.split("/");
  const lastSegment = pathSegments[pathSegments.length - 1];

  // For inactive studios, only allow billing settings
  useEffect(() => {
    if (lastSegment !== "billing" && !location.pathname.endsWith("/settings")) {
      navigate("/app/settings/billing", { replace: true });
    }
  }, [lastSegment, location.pathname, navigate]);

  // If user is on /app/settings, redirect to billing
  if (location.pathname.endsWith("/settings")) {
    return <Navigate to="/app/settings/billing" replace />;
  }

  return (
    <div className="relative bg-gray-50 dark:bg-gray-900">
      <div className="space-y-4 p-6 m-0">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              Settings
            </h1>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Manage your billing to reactivate your studio
            </p>
          </div>
        </div>



        {/* Only show billing tab */}
        <div className="hidden sm:block">
          <div className="border-b border-gray-200 dark:border-gray-700">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              <div className="group inline-flex items-center py-4 px-1 font-medium text-sm text-indigo-600 dark:text-indigo-400 border-b-2 border-indigo-600 dark:border-indigo-400">
                <CreditCardIcon
                  className="-ml-0.5 mr-2 h-5 w-5 text-indigo-600 dark:text-indigo-400"
                  aria-hidden="true"
                />
                <span>Billing</span>
              </div>
            </nav>
          </div>
        </div>

        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
